import React, { useContext } from 'react'
import {Box, Container, Typography} from '@mui/material'
import { useNavigate } from 'react-router'
import { NavigatorContext } from '../../contexts/NavigatorContext'



const logotext= {
  color: 'white',
  fontSize:'25px'
}
const logomid= {
  width: 40,
  height: 35,
  borderRadius: 2,
  color: 'white',
  backgroundColor: 'red'
}

export default function Logo() {
  const {setParam} = useContext(NavigatorContext);
  const navigate = useNavigate();
  const handleHome = (e)=>{
    e.persist();
    setParam('flight');
    navigate('/');
  }
  return (
    <Container onClick={handleHome}
    sx={{cursor:'pointer'}}
    >
        <Box
        display='flex'
        >
          <Typography 
          sx={logotext} 
          variant='h6'
          fontWeight='bold'
          component='h6'
          >make</Typography>
          <Typography 
          sx={logomid} 
          variant='h6'
          fontSize='h6.fontSize'
          textAlign= 'center'
          style={{fontFamily: 'Damion', fontSize:'25px', paddingBottom:"5px", display:'flex', justifyContent:'center', alignItems:'center'}}
          >my</Typography>
          <Typography 
          sx={logotext}
          variant='h6'
          fontWeight='bold'
          >trip</Typography>
        </Box>
    </Container>
  )
}
